export const environment = {
  production: false,
  API_BASE_URL: 'https://ekdarcanonprod.aws.rabo.cloud/api/v1/',
  msalConfig: {
    auth: {
      clientId: '935eff83-2db6-4d49-8949-ed0e73e1587b',
      uri: 'https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1/oauth2/v2.0/token',
      authority: 'https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1',
      tenantId: '6e93a626-8aca-4dc1-9191-ce291b4b75a1',
      redirectUri: '/',
      postLogoutRedirectUri: '/',
      scope: '935eff83-2db6-4d49-8949-ed0e73e1587b/.default'
    },
  },
  raboWeb: 'https://Raboweb.onmicrosoft.com/'
}
